import {h} from "preact";

export let SwitcherButtons = ({children}) => <div class="flex w-full mt-3 border-b border-slate-200 rounded-t-xl overflow-hidden cursor-pointer">{children}</div>
export let Button = ({children, selected, onClick}) => {
	if (selected)
		return <div class="w-full text-center py-2 text-xl uppercase bg-kobaaccent-500 text-slate-950">{children}</div>
	return <div class="w-full text-center py-2 text-xl uppercase bg-slate-100 text-slate-950" onClick={onClick}>{children}</div>
}

export let TabContainer = ({children}) => <div class="w-full bg-slate-100 text-slate-950">{children}</div>

export let MatchesTable = ({children}) => <div class="w-full">{children}</div>

export let MarketsStrip = ({children}) => <div class="flex w-full text-kobaaccent-500 font-bold">{children}</div>
export let MarketName = ({children, size}) => {
	if (size == 2)
		return <div class="text-center min-w-0 w-10 [flex-grow:2]">{children}</div>;
	return <div class="text-center min-w-0 w-10 [flex-grow:3]">{children}</div>;
}

export let Matches = ({children}) => <div class="pb-2 px-4">{children}</div>
export let MatchRow = ({children}) => <div class="border-t border-slate-200">{children}</div>

export let MatchInfo = ({children, onClick}) => <div class="mt-2" onClick={onClick}>{children}</div>

export let MatchTopInfo = ({children}) => <div class="flex justify-between w-full text-sm">{children}</div>
export let MatchTournament = ({event, tournament, category, sport}) => <div class="">{sport.name} - {category.name} - {tournament.name}</div>
export let MatchDate = ({children, date}) => <div class="text-slate-700">{new Date(date).toLocaleString()}</div>

export let MainMatchInfo = ({children}) => <div class="flex justify-between w-full">{children}</div>
export let MatchName = ({event}) => <div class="w-full">{event.home} - {event.away}</div>
export let AvailableMarkets = ({children, onClick}) => <div class="pt-0.5 px-2 bg-kobaaccent-500 text-black text-xs cursor-pointer hover:bg-kobaaccent-400" onClick={onClick}>More</div>

export let Markets = ({children}) => <div class="flex gap-2 my-3 w-full">{children}</div>
export let Market = ({children, size}) => {
	if (size == 2)
		return <div class="rounded-xl min-w-0 w-10 flex gap-1 justify-stretch items-stretch [flex-grow:2]">{children}</div>
	return <div class="rounded-xl min-w-0 w-10 flex gap-1 justify-stretch items-stretch [flex-grow:3]">{children}</div>
}
